import React from 'react';
import { goTo } from '../configTdm';
import IssueIcon from './issueIcon';
import { Issue } from '../headersegment/interfaces';

type MyIssuesTableProps = {
  issues: Issue[];
};

const MyIssuesTable: React.FC<MyIssuesTableProps> = ({ issues }) => {
  const goToTripIssue = (issue: Issue) => {
    goTo(`/trip/${issue.tripId}#issue-${issue.id}`);
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <table className="table table-striped table-hover my-issues-results">
            <tbody>
              {issues.map((issue: Issue) => (
                <tr key={issue.id} onClick={() => goToTripIssue(issue)}>
                  <td className="icon">
                    <IssueIcon type={issue.type} resolveByTime={issue.resolveByTime}></IssueIcon>
                  </td>
                  <td className="data">
                    <div className="row">
                      <div className="col-md-12">{issue.tripGroupName}</div>
                      <div className="col-md-12 visible-sm">{issue.recordLocator}</div>
                      <div className="col-md-12 visible-xs visible-md">
                        {(issue.recordLocator ?? '').length > 20
                          ? `${(issue.recordLocator ?? '').slice(0, 20)}...`
                          : issue.recordLocator}
                      </div>
                      <div className="col-md-12 visible-lg">
                        {(issue.recordLocator ?? '').length > 30
                          ? `${(issue.recordLocator ?? '').slice(0, 30)}...`
                          : issue.recordLocator}
                      </div>
                    </div>
                  </td>
                  <td className="arrow">
                    <div className="arrow"></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyIssuesTable;